import { BaseDto } from '@/shared/dtos/base-dto';

export class clients extends BaseDto {
    public name !: string;
    public email !: string;
    public phone !: string;
    public notes !: string;

 } 
